import { Typography } from '@recruit-robin/robin-theme/web-components';
import { AlertTriangle, XClose } from '@recruit-robin/robin-theme/web-icons';
import { useContext, useState } from 'react';
import { LocalizationContext } from 'shared/legacy/contexts/LocalizationContext/LocalizationContext';
import { useStyles } from './CommunicationChannelsWarning.styles';
import { CommunicationChannelsWarningProps } from './CommunicationChannelsWarning.types';

const NOT_ALL_COMMUNICATION_CHANNELS_CONNECTED = 'NOT_ALL_COMMUNICATION_CHANNELS_CONNECTED';

export const CommunicationChannelsWarning = ({ onClose, className }: CommunicationChannelsWarningProps) => {
  const { dictionary } = useContext(LocalizationContext);
  const classes = useStyles();
  const [isVisible, setIsVisible] = useState(() => {
    const hiddenAt = localStorage.getItem(NOT_ALL_COMMUNICATION_CHANNELS_CONNECTED);

    if (hiddenAt && Date.now() - JSON.parse(hiddenAt).hiddenAt < 1000 * 60 * 60 * 24 * 30) {
      return false;
    }

    return true;
  });

  const handleClose = () => {
    setIsVisible(false);
    onClose?.();

    localStorage.setItem(NOT_ALL_COMMUNICATION_CHANNELS_CONNECTED, JSON.stringify({ hiddenAt: Date.now() }));
  };

  if (!isVisible) {
    return null;
  }

  return (
    <div css={classes.root} className={className}>
      <div css={classes.iconContainer}>
        <div css={classes.icon}>
          <AlertTriangle size={14} color={(c) => c.tertiary.lime[60]} />
        </div>
      </div>
      <div css={classes.message}>
        <Typography color={(c) => c.tertiary.lime[60]} variant={(v) => v.supporting.helper}>
          {dictionary.communicationChannelsWarning}
        </Typography>
      </div>
      <div css={classes.closeContainer} onClick={handleClose}>
        <div css={classes.closeIcon}>
          <XClose size={24} />
        </div>
      </div>
    </div>
  );
};
